var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_8685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_8685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8335 41.3334L27.1668 31.3334L16.5001 30L32.5001 14.6667H35.1668L29.8335 24.6667L40.5001 26L24.5001 41.3334H21.8335ZM29.2335 33.1L34.6001 27.9667L25.6335 26.8334L27.7335 22.9334L22.4001 28.0667L31.3335 29.1667L29.2335 33.1Z",
    fill: "#21ADE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.8bb47a2821501bd608cfe6922c54d87c.svg";
export { ForwardRef as ReactComponent };